//--------------------------------------------------
//Navbar for the application on mobile view
//--------------------------------------------------

import React from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLinkedin, faSquareFacebook, faGithub } from '@fortawesome/free-brands-svg-icons';
import { Container, Row, Col, Navbar } from 'react-bootstrap'

import me from '../../Images/Ho2025.jpg'

const NavigationBar = ({ scrollToRef, aboutRef, projectRef, resumeRef }) => {
    return (
        <Navbar expand="lg" className="nav-bar">
            <Container>
                <Row className='justify-content-center nav-bar-contents'>
                    <Col xs sm={3}>
                        <img src={me} alt='Self Portrait' />
                        <h1>JC Ho</h1>
                    </Col>
                    <Col xs sm={3}>
                        <h2 onClick={() => scrollToRef(aboutRef)}>About Me</h2>
                        <h2 onClick={() => scrollToRef(projectRef)}>Projects</h2>
                        <h2 onClick={() => scrollToRef(resumeRef)}>Resume</h2>
                    </Col>
                    <Col xs sm={3}>
                        <h4>Contact Me</h4>
                        <p><a href={`tel:+12085078846`}>(208) 507-8846</a></p>
                        <p><a href= "mailto: leiadog11@gmail.com">leiadog11@gmail.com</a></p>
                    </Col>
                    <Col xs sm={3}>
                        <div className='icons'>
                            <Link to='https://www.linkedin.com/in/jcrho/' target='_blank'>
                                <span><FontAwesomeIcon icon={faLinkedin} /></span>
                            </Link>
                            <Link to='https://www.facebook.com/heck.heck.334/' target='_blank'>
                                <span><FontAwesomeIcon icon={faSquareFacebook} /></span>
                            </Link>
                            <Link to='https://github.com/leiadog11' target='_blank'>
                                <span><FontAwesomeIcon icon={faGithub} /></span>
                            </Link>
                        </div>
                    </Col>
                </Row>
            </Container>
        </Navbar>
    )
};

function mapState(state) {
    const { session } = state;
    return { session };
}

const actionCreators = {

};

const connection = connect(mapState, actionCreators)(NavigationBar);
export { connection as NavigationBar };